import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Container, Grid, Stack, SwipeableDrawer, TextField, Typography } from '@mui/material';
import { dispatch, useSelector } from '../../../redux/store';
import { PATH_DASHBOARD } from '../../../routes/paths';
import useSettings from '../../../hooks/useSettings';
import Page from '../../../components/Page';
import Iconify from '../../../components/Iconify';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import DataGridTable from '../../../components/table/DataGridTable';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { accessVerify, capitalize, safeJSONParse } from '../../../utils/common';
import PermissionRequired from '../../errorPages/permissionRequired';
import { addExpenseCategories, getExpenseCategories, updateExpenseCategories } from '../../../redux/slices/expenseRedux/expenseCategoriesRedux';
import { useParams } from 'react-router-dom';

export default function ExpenseCategories() {
  const { mainCategory } = useParams();
  const dataModel = {
    id: '',
    mainCategory: mainCategory,
    name: '',
    description: '',
  };
  const [selectedDataObj, setSelectedDataObj] = useState(dataModel);
  const { themeStretch } = useSettings();
  const [isAdd, setIsAdd] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [assetsList, setAssetsList] = useState([]);
  const [isCustomField, setIsCustomField] = useState(false);
  const { data, addData } = useSelector((state) => state.expenseCategories);

  useEffect(() => {
    dispatch(getExpenseCategories());
  }, []);

  useEffect(() => {
    setAssetsList(
      data
        ?.filter((value) => value?.mainCategory === mainCategory)
        ?.map((value) => {
          return {
            ...value,
            locationData: safeJSONParse(value?.locationData),
            userData: safeJSONParse(value?.userData),
          };
        })
    );
    setIsModelOpen(false);
  }, [data]);

  const manageModel = (modelData, type) => {
    if (isModelOpen) {
      setIsModelOpen(false);
    } else {
      setIsModelOpen(true);
      setIsAdd(type === 'add');
      if (type === 'add') {
        setSelectedDataObj(dataModel);
      } else {
        setSelectedDataObj(modelData);
      }
      setIsCustomField(false);
    }
  };

  useEffect(() => {
    if (addData?.data) {
      dispatch(getExpenseCategories());
    }
  }, [addData]);

  const updateEditingData = (key, value) => {
    setSelectedDataObj({
      ...selectedDataObj,
      [key]: value,
    });
  };

  const columns = !assetsList?.[0]
    ? []
    : ['id', 'name', 'description', 'mainCategory', 'locationData', 'userData']
        .map((value) => {
          if (['isVerifier', 'isIncrement', 'locationData', 'userData'].includes(value)) {
            return {};
          } else if (['mainCategory'].includes(value)) {
            return {
              accessorKey: value,
              header: capitalize(value),
              Cell: ({ row }) => `${capitalize(row?.original?.mainCategory)}`,
            };
          } else if (['name'].includes(value)) {
            return {
              accessorKey: value,
              header: 'Sub Category',
              Cell: ({ row }) => `${capitalize(row?.original?.name)}`,
            };
          } else {
            return {
              accessorKey: value,
              header: capitalize(value),
            };
          }
        })
        ?.filter((value) => value?.accessorKey);

  const [rowSelection, setRowSelection] = useState(false);

  const handleSubmit = () => {
    if (selectedDataObj.name.length === 0) {
      toast.error('Asset name is required!');
    } else if (selectedDataObj.description.length === 0) {
      toast.error('Asset description is required!');
    } else {
      dispatch(isAdd ? addExpenseCategories(selectedDataObj) : updateExpenseCategories(selectedDataObj));
    }
  };

  return (
    <Page title={`Expense Categories`}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={`Expense Sub Categories`}
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Finance',
              href: '',
            },
            { name: `Expense Sub Categories` },
          ]}
          action={
            <Button
              variant='contained'
              startIcon={<Iconify icon='eva:plus-fill' />}
              onClick={() => {
                manageModel(dataModel, 'add');
              }}
            >
              New Expense Sub Category
            </Button>
          }
        />
        <DataGridTable
          name={'Payment Types'}
          data={assetsList}
          column={columns}
          isLoading={false}
          onRowClick={(row) => {
            manageModel(row?.original, 'edit');
          }}
          isRowClickable={true}
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          enableRowSelection={false}
          enableRowActions={false}
          renderRowActionItems={(value, closeMenu) => []}
        />

        <SwipeableDrawer
          anchor={'top'}
          open={isModelOpen}
          onOpen={() => setIsModelOpen(true)}
          onClose={() => setIsModelOpen(false)}
          PaperProps={{
            sx: {
              width: '90%',
              height: '90%',
              marginLeft: '5%',
              marginTop: '3%',
              borderRadius: '10px',
            },
          }}
        >
          <Box sx={{ p: 2 }}>
            <h1>{isAdd ? 'Add' : 'Edit'} Expense Sub Categories</h1>
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={12} md={8}>
              <Stack spacing={3} sx={{ p: 3 }}>
                <Card sx={{ p: 3 }}>
                  <Typography variant='subtitle1' padding='10px 0'>
                    Main Category
                  </Typography>
                  <Stack spacing={3}>
                    {/*{isCustomField ? (*/}
                    {/*  <Button*/}
                    {/*    color={'primary'}*/}
                    {/*    variant='contained'*/}
                    {/*    onClick={() => {*/}
                    {/*      setIsCustomField(false);*/}
                    {/*    }}*/}
                    {/*  >*/}
                    {/*    Use Already Entered Main Category One*/}
                    {/*  </Button>*/}
                    {/*) : (*/}
                    {/*  <Button*/}
                    {/*    color={'primary'}*/}
                    {/*    variant='contained'*/}
                    {/*    onClick={() => {*/}
                    {/*      setIsCustomField(true);*/}
                    {/*    }}*/}
                    {/*  >*/}
                    {/*    Continue with New Main Category*/}
                    {/*  </Button>*/}
                    {/*)}*/}

                    {/*{!isCustomField ? (*/}
                    {/*  <Autocomplete*/}
                    {/*    onChange={(event, newValue) => {*/}
                    {/*      updateEditingData('mainCategory', newValue?.value);*/}
                    {/*    }}*/}
                    {/*    options={ExpenseMainCategoryTypes || []}*/}
                    {/*    value={ExpenseMainCategoryTypes?.find((value) => value?.value === selectedDataObj?.mainCategory) ?? null}*/}
                    {/*    renderInput={(params) => <TextField label='Main Category' {...params} />}*/}
                    {/*    getOptionLabel={(option) => option.label || ''}*/}
                    {/*    isOptionEqualToValue={(option, value) => option.value === value.value}*/}
                    {/*  />*/}
                    {/*) : (*/}
                    {/*  <TextField fullWidth label='Custom Main Category' value={selectedDataObj?.mainCategory} onChange={(e) => updateEditingData('mainCategory', e.target.value)} />*/}
                    {/*)}*/}
                    <TextField fullWidth label='Name' value={selectedDataObj?.name} onChange={(e) => updateEditingData('name', e.target.value)} />
                    <TextField fullWidth label='Description' value={selectedDataObj?.description} onChange={(e) => updateEditingData('description', e.target.value)} />
                  </Stack>
                </Card>
              </Stack>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ p: 3 }}>
                  <LoadingButton type='submit' variant='contained' size='large' style={{ width: '100%' }} onClick={handleSubmit}>
                    {isAdd ? 'Add Expense Categories' : 'Save Changes'}
                  </LoadingButton>
                  <Button
                    color='info'
                    variant='outlined'
                    size='large'
                    style={{ width: '100%' }}
                    onClick={() => {
                      manageModel(dataModel, 'add');
                    }}
                  >
                    Close
                  </Button>
                </Stack>
              </Card>
            </Grid>
          </Grid>
        </SwipeableDrawer>
      </Container>
    </Page>
  );
}
